import React from 'react';
import "./LoadingIndicator.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/pro-regular-svg-icons'

interface LoadingIndicatorProps {
	loadingText?: string;
}

function LoadingIndicator(props: LoadingIndicatorProps) {
	const loadingText = props.loadingText === undefined ? "Loading..." : props.loadingText;

	return (
		<div className="loading-indicator">
			<FontAwesomeIcon icon={faSpinner} pulse /> {loadingText}
		</div>
	);
}

export default LoadingIndicator;